export interface PageHint {
  selector: string;
  titleKey: string;
  descriptionKey: string;
}

export interface OnboardingStep {
  anchor: string;
  route?: string;
  titleKey: string;
  descriptionKey: string;
  pageHints?: PageHint[];
}

export const ONBOARDING_STEPS: OnboardingStep[] = [
  {
    anchor: "games-section",
    route: "/",
    titleKey: "Onboarding.games-title",
    descriptionKey: "Onboarding.games-description",
  },
  {
    anchor: "integrations-section",
    route: "/integrations",
    titleKey: "Onboarding.integrations-title",
    descriptionKey: "Onboarding.integrations-description",
  },
  {
    anchor: "players-section",
    route: "/users",
    titleKey: "Onboarding.players-title",
    descriptionKey: "Onboarding.players-description",
  },
  {
    anchor: "nav-Analytics",
    route: "/events",
    titleKey: "Onboarding.analytics-title",
    descriptionKey: "Onboarding.analytics-description",
  },
];
